// extracted by mini-css-extract-plugin
export default {"table":"order_table__pgH9y","main":"order_main__JC8lZ","form":"order_form__lRmtM"};